import React from "react";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectToken } from "../store/slices/authSlice";
import { Navigate } from "react-router-dom";

const GuestRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const token = useSelector(selectToken);
  const isUserAuthenticated = isAuthenticated && token;
  
  // If user is authenticated, redirect to dashboard
  if (isUserAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  // If not authenticated, allow access to guest routes
  return children;
};

export default GuestRoute;
